import API from './../../api'
import Vue from 'vue';
import _ from 'lodash';
import router from './../../router'

/**
 * Person Form Validator
 */
export default {
  namespaced: true,
  state: {
    userRequests: [],
  },
  mutations: {
    setRequest (state, requests) {
      state.userRequests = requests;
    },
    updateRequest (state, payload) {
      Vue.set(state.userRequests, payload['k'], _.merge(state.userRequests[payload['k']], payload['v']));
    },
  },
  actions: {
    getRequests: async ({ commit }) => {
      commit('setLoading', true, { root: true })
      try {
        let requests = await API.getUserRequests();
        commit('setLoading', false, { root: true});
        commit('setRequest', requests);
      } catch (e) {
        commit('setLoading', false, { root: true });
        commit('setRequest', []);
      }
    },

    goToPage: async (pageId) => {
        await router.push('/' + pageId);
        return true;
    },

    deleteRequest: async ({ commit, state }, i) => {
      commit("updateRequest", { k: i, v: {
          "status": "PENDING_DELETE",
        }});

      try {
        await API.deleteUserRequests(state.userRequests[i]['requestId']);
      } catch (e) {
        console.log(e);
      }
    },

    toggleNotification: async ({ commit, state }, i) => {
      let subscription = state.userRequests[i]['subscription'] === "SUBSCRIBED" ? 'AD_HOC' : "SUBSCRIBED";
      commit("updateRequest", { k: i, v: {
          "subscription": subscription
      }});

      try {
        await API.subToggle(state.userRequests[i]['requestId']);
      } catch (e) {
        console.log(e);
      }

      return true;
    },
  },

  getters: {
    hasRequest: state => state.userRequests.length > 0,
    userRequests: state => state.userRequests,
  }
}
